import { COMMENDA_AI_FILE_METADATA_KEY } from '@commenda/api/commenda-ai/constants';
import {
  CommendaAiFileSource,
  type CommendaAiGeneratedFileMetadata,
  type CommendaAiSavedFile,
} from '@commenda/api/commenda-ai/types';
import type { FileUIPart } from 'ai';
import { z } from 'zod';

const savedFileSchema = z.object({
  fileId: z.number(),
  entityId: z.number(),
  folderId: z.string(),
  filePlacementId: z.string().nullable(),
  savedByUserId: z.string(),
  savedAt: z.string(),
});

const generatedFileMetadataSchema = z.object({
  source: z.nativeEnum(CommendaAiFileSource),
  suggestion: z
    .object({
      entityId: z.number().optional(),
      documentSubType: z.string().optional(),
      effectiveStartDate: z.string().optional(),
      effectiveEndDate: z.string().optional(),
      folderId: z.string().optional(),
    })
    .optional(),
  saved: savedFileSchema.optional(),
});

export class GeneratedFileHelper {
  static getMetadata(part: FileUIPart): CommendaAiGeneratedFileMetadata | null {
    const parsed = generatedFileMetadataSchema.safeParse(
      part.providerMetadata?.[COMMENDA_AI_FILE_METADATA_KEY]
    );
    if (!parsed.success) return null;
    // Validated above; apps compiled without `strict` widen zod's output to all-optional fields.
    return parsed.data as CommendaAiGeneratedFileMetadata;
  }

  /** The Documents page opened on the folder the file was saved into, with the file highlighted. */
  static getDocumentsPath(saved: CommendaAiSavedFile): string {
    const params = new URLSearchParams({
      corporationId: saved.entityId.toString(),
      folderId: saved.folderId,
    });
    if (saved.filePlacementId) params.set('placementId', saved.filePlacementId);
    return `/documents?${params}`;
  }
}
